export default {
  GET_TASK_LIST(state, payload) {
    state[payload.key] = payload.value;
  },
};
